import React from 'react';

const SvgUsers: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 37" {...props}>
      <defs>
        <clipPath id="users_svg__a">
          <path fill="none" d="M0 0h37v37H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#users_svg__a)"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M32.967 16.887a3.118 3.118 0 11-3.117-3.117 3.117 3.117 0 013.117 3.117zM23.302 12.508a4.8 4.8 0 11-4.8-4.8 4.8 4.8 0 014.8 4.8zM4.033 16.887A3.118 3.118 0 107.15 13.77a3.117 3.117 0 00-3.117 3.117zM35.458 29.291V27.6a3.855 3.855 0 00-3.854-3.857H30.37M1.542 29.291V27.6a3.855 3.855 0 013.854-3.857h1.235M26.73 29.292v-2.47a5.4 5.4 0 00-5.4-5.4h-5.667a5.4 5.4 0 00-5.4 5.4v2.47" />
      </g>
    </svg>
  );
};

export default SvgUsers;
